"use client";

import { ReactNode } from "react";
import { useAuth } from "@clerk/nextjs";
import { getIsTeacherFromSessionClaims } from "@/utils/getIsTeacherFromSessionClaims";
import { isActiveOrganizationApproved } from "@/organizations/activeOrganization";

export const TeacherAuthorizedWrapper = ({
  children,
  fallback = null,
  requireApprovedSchool = false,
}: {
  children: ReactNode;
  fallback?: ReactNode;
  requireApprovedSchool?: boolean;
}) => {
  const { sessionClaims, isSignedIn } = useAuth();

  if (!isSignedIn) {
    return fallback;
  }

  const isTeacher = getIsTeacherFromSessionClaims(sessionClaims);

  if (!isTeacher) {
    return fallback;
  }

  if (requireApprovedSchool && !isActiveOrganizationApproved(sessionClaims)) {
    return fallback;
  }

  return <>{children}</>;
};
